import { set, map, findIndex, omit } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { RESET_USERSTORY_DOCUMENT, SET_USERSTORY_DOCUMENT, ADD_USERSTORY_DOCUMENT_VERSION } from 'vx/mutations'

const initialDocState = () => {
  return {
    epics: [],
    versions: []
  }
}

// User state.
const state = {
  user_story_document: initialDocState(),
}

// User state getters.
const getters = {}

// User actions.
const actions = {

  getUserStoryDocument ({ commit }, id) {
    commit(RESET_USERSTORY_DOCUMENT)
    commit('epics/SET_EPICS', [], { root: true })

    return http.get(`/user-story-document/${id}`).then(response => {
      commit(SET_USERSTORY_DOCUMENT, response.data.data)
      commit('epics/SET_EPICS', response.data.data.epics, { root: true })
      commit('groups/SET_GROUPS', response.data.data.groups, { root: true })

      return response
    })
  },

  createUserStoryDocumentVersion ({ commit }, { docId,  payload }) {
    return http.post(`/user-story-document/${docId}/versions`, payload).then(response => {
      commit(ADD_USERSTORY_DOCUMENT_VERSION, response.data)

      return response
    })
  },

  resetDoc({ commit }) {
    commit(RESET_USERSTORY_DOCUMENT)
  }
}

// User state mutations.
const mutations = {

  /**
  * Set the project state.
  */
  [SET_USERSTORY_DOCUMENT] (state, user_story_document) {
    state.user_story_document = user_story_document
  },

  [ADD_USERSTORY_DOCUMENT_VERSION] (state, version) {
    let versionIndex = findIndex(state.user_story_document.versions, existing => existing.id === version.id)

    if (versionIndex === -1) {
      state.user_story_document.versions.unshift(version)
    } else {
      state.user_story_document.versions.splice(versionIndex, 1, version)
    }
  },
  
  [RESET_USERSTORY_DOCUMENT] (state) {
    state.user_story_document = initialDocState()
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
